const handleSearchListeners = ({
  clearBtn,
  clearInput,
  focusOnHotkey,
  input,
  onValueChange
}) => {
  if (!input || !clearBtn) {
    return () => null;
  }
  const handleWindowKeyDown = (e) => {
    if (focusOnHotkey && (e.key === "k" || e.key === "/") && e.metaKey) {
      input?.focus();
    }
  };
  window.addEventListener("keydown", handleWindowKeyDown);
  input.addEventListener("input", onValueChange);
  clearBtn.addEventListener("click", clearInput);
  return () => {
    window.removeEventListener("keydown", handleWindowKeyDown);
    input.removeEventListener("keyup", onValueChange);
    clearBtn.removeEventListener("click", clearInput);
  };
};
const handleSearchExpansion = ({
  collapse,
  collapsible,
  container,
  expand,
  input
}) => {
  if (!input) {
    return () => null;
  }
  const handleExpand = (e) => {
    if (e.type === "keydown") {
      if (e.key === " " || e.key === "Enter") {
        e.preventDefault();
        if (expand)
          expand();
      }
    } else {
      if (expand)
        expand();
    }
  };
  const handleCollapse = (e) => {
    if (!input.value) {
      if (!container?.contains(e.relatedTarget)) {
        if (collapse)
          collapse();
      }
    }
  };
  if (collapsible) {
    container?.addEventListener("click", handleExpand);
    container?.addEventListener("keydown", handleExpand);
    container?.addEventListener("focusout", handleCollapse);
  }
  return () => {
    container?.removeEventListener("click", handleExpand);
    container?.removeEventListener("keydown", handleExpand);
    container?.removeEventListener("focusout", handleCollapse);
  };
};
const initSearchInput = (component, props = {}) => {
  const input = component.querySelector(".tds-form-input-search");
  const clearBtn = component.querySelector(".tds-form-input-search-clear");
  const { onValueChange: externalOnValueChange } = props;
  if (!input || !clearBtn) {
    console.warn(
      "TDS Search Input malformed, requires an input element with .tds-form-input-search"
    );
    return () => null;
  }
  const onValueChange = () => {
    if (input.value) {
      component.dataset.tdsValue = input.value;
    } else {
      delete component.dataset.tdsValue;
    }
    if (externalOnValueChange)
      externalOnValueChange(input.value);
  };
  const clearInput = () => {
    input.value = "";
    onValueChange();
    input.focus();
  };
  const collapsible = component?.classList.contains("tds-form-input--collapsed");
  const expand = () => {
    component.classList.remove("tds-form-input--collapsed");
  };
  const collapse = () => {
    component.classList.add("tds-form-input--collapsed");
  };
  const cleanup = handleSearchListeners({
    clearBtn,
    clearInput,
    container: component,
    focusOnHotkey: props.focusOnHotkey || Boolean(component.dataset.focusOnHotkey),
    input,
    onValueChange
  });
  const expansionCleanup = handleSearchExpansion({
    collapse,
    collapsible,
    container: component,
    expand,
    input
  });
  return () => {
    cleanup();
    expansionCleanup();
  };
};
const initSearchInputs = (props = {}) => {
  const { parent = document } = props;
  const inputs = Array.from(parent.querySelectorAll(".tds-form-input-search"));
  inputs.forEach((input) => {
    const component = input.closest(".tds-form-input");
    if (component) {
      initSearchInput(component, { ...props });
    }
  });
};
export {
  handleSearchExpansion,
  handleSearchListeners,
  initSearchInput,
  initSearchInputs
};
